import type { ComponentType } from 'react';

import type { OccasionId } from './occasions';

import styles from './ThemeToggle.module.scss';

/*
Costumes are drawn in the anglerfish's 24 x 24 grid, on top of its body and behind the lure,
which keeps glowing in the dark theme. Colours come from the stylesheet, keyed on the switch's
`data-state`, like the fish itself.
*/

function WitchHat() {
    return (
        <>
            <path
                className={styles.witchHat}
                d="M5.2 8.9 C6.4 6.8 7.6 4.9 7.4 2.2 C9.2 3.6 10 5.6 10.5 7.4 Z"
            />
            <path
                className={styles.witchBand}
                d="M5.9 8.1 C7.3 7.3 8.8 6.9 10.3 6.8 L10.5 7.5 C8.9 7.6 7.4 8.1 6.1 8.9 Z"
            />
            <path
                className={styles.witchHat}
                d="M3.9 9.8 C6.3 8 9.3 7 12.3 7.1 L12.3 7.8 C9.4 7.8 6.6 8.8 4.4 10.4 Z"
            />
        </>
    );
}

function SantaHat() {
    return (
        <>
            <path
                className={styles.santaHat}
                d="M5.4 9.3 C6.2 6.4 7.6 4.4 9.6 3.5 C9.4 5 9.9 6.4 10.9 7.4 Z"
            />
            <path
                className={styles.santaTrim}
                d="M4.9 9.5 C6.6 8.1 9 7.2 11.2 7.1 L11.4 8.3 C9.2 8.4 6.9 9.2 5.4 10.6 Z"
            />
            <circle className={styles.santaTrim} cx="9.8" cy="3.4" r="1" />
        </>
    );
}

function PartyHat() {
    return (
        <>
            <path className={styles.partyHat} d="M5.6 8.9 L7.1 2.6 L10.8 7.4 Z" />
            <path
                className={styles.partyStripe}
                d="M6.1 6.8 L9.2 5.3 L9.8 6.1 L6.0 7.6 Z M6.6 4.7 L7.9 3.8 L8.5 4.5 L6.4 5.6 Z"
            />
            <circle className={styles.partyPom} cx="7.1" cy="2.3" r="0.95" />
        </>
    );
}

function BunnyEars() {
    return (
        <>
            <path
                className={styles.bunnyEar}
                d="M6.6 8.6 C5.2 6.6 4.9 3.4 5.9 1.6 C7.4 2.6 8.4 5.4 8.3 8 Z"
            />
            <path
                className={styles.bunnyEarInner}
                d="M6.9 7.8 C6.2 6.2 6 4.2 6.3 2.9 C7.1 3.9 7.6 5.8 7.6 7.6 Z"
            />
            <path
                className={styles.bunnyEar}
                d="M8.7 7.6 C8.5 5.3 9.2 2.4 10.6 1.1 C11.6 2.6 11.2 5.5 10.3 7.4 Z"
            />
            <path
                className={styles.bunnyEarInner}
                d="M9.2 7.2 C9.1 5.6 9.6 3.6 10.4 2.4 C10.8 3.7 10.6 5.6 10 7 Z"
            />
        </>
    );
}

/** The New Year party hat in the Norwegian flag's colours, with its white and blue cross. */
function FlagPartyHat() {
    return (
        <>
            <path className={styles.flagHatRed} d="M5.4 9.1 L7.1 2.2 L11.2 7.5 Z" />
            <path
                className={styles.flagHatWhite}
                d="M6.6 3.9 L7.65 3.5 L9.4 8.25 L8.15 8.55 Z M5.75 7.35 L10.15 6.15 L10.55 6.85 L5.6 8.05 Z"
            />
            <path
                className={styles.flagHatBlue}
                d="M7.0 3.85 L7.45 3.7 L8.95 8.35 L8.5 8.45 Z M5.7 7.62 L10.32 6.42 L10.44 6.62 L5.66 7.8 Z"
            />
            <circle className={styles.flagHatWhite} cx="7.1" cy="1.95" r="1" />
        </>
    );
}

const COSTUMES: Record<OccasionId, ComponentType> = {
    halloween: WitchHat,
    christmas: SantaHat,
    newYear: PartyHat,
    easter: BunnyEars,
    may17: FlagPartyHat,
};

export function AnglerfishCostume({ occasion }: { occasion: OccasionId }) {
    const Costume = COSTUMES[occasion];
    return (
        <g data-occasion={occasion}>
            <Costume />
        </g>
    );
}
